import React from 'react'

interface SvgIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string
}

const SvgIcon: React.FC<SvgIconProps> = ({ fill = 'currentColor', ...props }) => {
  return (
    <svg {...props} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <rect data-name="Rectangle 1672" width="48" height="48" rx="23" opacity={0.25} />
      <g data-name="Group 3965">
        <path
          data-name="Path 1137"
          d="M92.067 10.1a4.865 4.865 0 0 0 3.561-1.48A4.9 4.9 0 0 0 97.1 5.051a4.9 4.9 0 0 0-1.472-3.571 5.024 5.024 0 0 0-7.121 0 4.9 4.9 0 0 0-1.475 3.572 4.9 4.9 0 0 0 1.476 3.572 4.867 4.867 0 0 0 3.559 1.476zm0 0"
          transform="translate(-68.199 13.513)"
        />
        <path
          data-name="Path 1138"
          d="M17.4 253.313a12.515 12.515 0 0 0-.169-1.325 10.469 10.469 0 0 0-.325-1.332 6.59 6.59 0 0 0-.546-1.243 4.687 4.687 0 0 0-.823-1.076 3.628 3.628 0 0 0-1.183-.745 4.077 4.077 0 0 0-1.51-.274 1.531 1.531 0 0 0-.819.348c-.245.16-.532.346-.853.551a4.878 4.878 0 0 1-1.1.488 4.27 4.27 0 0 1-2.7 0 4.862 4.862 0 0 1-1.1-.487c-.317-.2-.6-.389-.853-.552a1.528 1.528 0 0 0-.818-.348 4.073 4.073 0 0 0-1.51.274 3.627 3.627 0 0 0-1.183.746 4.688 4.688 0 0 0-.823 1.076 6.6 6.6 0 0 0-.546 1.243 10.492 10.492 0 0 0-.325 1.332 12.469 12.469 0 0 0-.169 1.326c-.028.4-.042.818-.042 1.239a3.488 3.488 0 0 0 1.031 2.635 3.705 3.705 0 0 0 2.657.972h10.065a3.7 3.7 0 0 0 2.657-.972 3.487 3.487 0 0 0 1.031-2.635c0-.425-.014-.842-.044-1.241zm0 0"
          transform="translate(15.278 -223.673)"
        />
      </g>
    </svg>
  )
}

type UserIconFilledProps = SvgIconProps

export const UserIconFilled: React.FC<UserIconFilledProps> = (props) => {
  return <SvgIcon {...props} viewBox="0 0 48 48" focusable="false" aria-hidden="true" />
}
